export interface ModalTitle {
  title?: string;
  content?: string;
}

export  const DefaultModalTitle: ModalTitle = {
  content: "",
  title: ""
};
